import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteAgenticPrompt } from 'services/agenticPrompts'
import { useNotification } from 'components/Notification'
import { useConfirmationDialog } from 'components/ConfirmationDialog'

import { AGENTIC_PROMPTS_QUERY_KEY } from './useAgenticPrompts'

function useDeleteAgenticPrompt() {
  const queryClient = useQueryClient()
  const { createNotification } = useNotification()
  const { createConfirmationDialog } = useConfirmationDialog()

  const { mutate, isLoading: isDeleting } = useMutation({
    mutationFn: id => deleteAgenticPrompt(id),
    onSuccess: () => {
      createNotification({ message: 'Prompt deleted', variant: 'success' })
      queryClient.invalidateQueries({ queryKey: [AGENTIC_PROMPTS_QUERY_KEY] })
    },
    onError: error => {
      const message =
        error?.response?.data?.errors?.[0]?.message ||
        error?.response?.data?.errors?.[0] ||
        error?.message ||
        'Failed to delete prompt'
      createNotification({ message, variant: 'error' })
    },
  })

  function deletePrompt(prompt) {
    createConfirmationDialog({
      title: 'Delete prompt?',
      body: `"${prompt.title}" will be removed from the assistant library. This cannot be undone from the admin UI.`,
      confirmButtonText: 'Delete',
      onConfirm: () => mutate(prompt.id),
    })
  }

  return { deletePrompt, isDeleting }
}

export { useDeleteAgenticPrompt }
